import * as React from "react";
import { forwardRef } from "react";
const SvgXIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.8014 3H20.867L14.136 10.6384L22 21H15.8287L10.997 14.7033L5.46551 21H2.39987L9.53082 12.8303L2 3H8.32456L12.6898 8.75203L17.8014 3ZM16.7284 19.2066H18.4279L7.43152 4.72694H5.60546L16.7284 19.2066Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgXIcon);
export { ForwardRef as ReactComponent };
